import { combineReducers } from 'redux';
import comments from './comments/commentsReducer';
import ui from './ui/uiReducer';
import user from './user/userReducer';
import mentioning from './mentioning/mentioningReducer';
import settings from './settings/settingsReducer';
import communities from './community/communityReducer';
import content from './content/contentReducer';

export default combineReducers({
  commenting: comments,
  ui,
  user,
  mentioning,
  settings,
  communities,
  content
});
